import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollAnimation({ children }) {
  const { pathname } = useLocation();
  const [transitionStage, setTransitionStage] = useState("fadeIn");

  useEffect(() => {
    // ⭐ Start fade-out animation
    setTransitionStage("fadeOut");

    // ⭐ After animation end, scroll top + trigger fade-in
    const timeout = setTimeout(() => {
      window.scrollTo(0, 0);
      setTransitionStage("fadeIn");
    }, 250); // animation time (must match CSS)

    return () => clearTimeout(timeout);
  }, [pathname]);

  return (
    <div className={`page-wrapper ${transitionStage}`}>
      {children}
    </div>
  );
}
